import { useState, useEffect, useRef } from "react";

export default function ScaleToWidth({
   contentWidth,
   contentHeight,
   children,
   noMaxWidth = false,
}) {
   const [windowSize, setWindowSize] = useState({});
   const container = useRef();

   const scale = container.current
      ? parseInt(window.getComputedStyle(container.current).width) /
        contentWidth
      : 0;

   useEffect(() => {
      function handleResize() {
         setWindowSize({
            height: window.innerHeight,
            width: window.innerWidth,
         });
      }

      window.addEventListener("resize", handleResize);

      return (_) => {
         window.removeEventListener("resize", handleResize);
      };
   });

   useEffect(() => {
      setWindowSize({
         height: window.innerHeight,
         width: window.innerWidth,
      });
   }, []);

   return (
      <div
         style={{
            width: "100%",
            maxWidth: noMaxWidth ? "none" : contentWidth,
            height: contentHeight * scale,
            overflow: "hidden",
         }}
         ref={container}
      >
         {scale && (
            <div
               style={{
                  transform: "scale(" + scale + ")",
                  transformOrigin: "top left",
                  position: "absolute",
                  width: contentWidth,
                  height: contentHeight,
               }}
            >
               {children({ scale })}
            </div>
         )}
      </div>
   );
}
